var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33837 7.66195C4.56073 7.4572 4.86131 7.35522 5.16484 7.3821C8.41097 7.66933 14.4676 6.13121 18.4261 2.14742C18.701 1.87073 19.2019 2.02726 19.517 2.25862C23.9194 5.49509 31.2167 6.1652 33.7496 6.30223C34.2737 6.33069 34.6988 6.73044 34.7529 7.24402C37.0566 29.1298 22.5697 37.0605 19.5652 38.4605C19.2368 38.6136 18.8502 38.5912 18.5416 38.4023C3.56682 29.2273 4.20737 17.2957 4.00028 8.45486C3.99332 8.15525 4.11601 7.86697 4.33837 7.66195Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_357_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19.5C21.2496 19.5 22.6667 18.0829 22.6667 16.3333C22.6667 14.5838 21.2496 13.1667 19.5 13.1667C17.7504 13.1667 16.3333 14.5838 16.3333 16.3333C16.3333 18.0829 17.7504 19.5 19.5 19.5ZM19.5 21.0833C17.3863 21.0833 13.1667 22.1442 13.1667 24.25V25.8333H25.8333V24.25C25.8333 22.1442 21.6138 21.0833 19.5 21.0833Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_357_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.f1534bd0a39a47e2db69ddf3acba68d7.svg";
export { ForwardRef as ReactComponent };